export const INIT_SHOP = 'INIT_SHOP'
export const RESET_SHOP = 'RESET_SHOP'
export const UPDATE_CHECKOUT = 'UPDATE_CHECKOUT'
export const ADD_TO_CART = 'ADD_TO_CART'
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY'
export const UPDATE_CHECKOUT_INFORMATIONS = 'UPDATE_CHECKOUT_INFORMATIONS'
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const CHECKOUT_LOADING = 'CHECKOUT_LOADING'
export const ADD_VOUCHER = 'ADD_VOUCHER'
export const SET_HIGHEST_PRODUCT_TYPE = 'SET_HIGHEST_PRODUCT_TYPE'
export const CREATE_GIFT_DISCOUNT = 'CREATE_GIFT_DISCOUNT'
